// https://stackoverflow.com/a/33352604
export const generateArray = (length) => [...Array(length).keys()];
